/**
 * @generated SignedSource<<580d6b00fad70cf917979111a310b27a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DesktopLaunchPageAutomatedLoginTicketMutation$variables = {
  path: string;
};
export type DesktopLaunchPageAutomatedLoginTicketMutation$data = {
  readonly generateLoginTicket: {
    readonly ticket: string;
  } | null;
};
export type DesktopLaunchPageAutomatedLoginTicketMutation = {
  response: DesktopLaunchPageAutomatedLoginTicketMutation$data;
  variables: DesktopLaunchPageAutomatedLoginTicketMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "path"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "path",
        "variableName": "path"
      }
    ],
    "concreteType": "GenerateLoginTicket",
    "kind": "LinkedField",
    "name": "generateLoginTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticket",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DesktopLaunchPageAutomatedLoginTicketMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DesktopLaunchPageAutomatedLoginTicketMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "329044d5f010ba15c7b6a3ae5a8b1555",
    "id": null,
    "metadata": {},
    "name": "DesktopLaunchPageAutomatedLoginTicketMutation",
    "operationKind": "mutation",
    "text": "mutation DesktopLaunchPageAutomatedLoginTicketMutation(\n  $path: String!\n) {\n  generateLoginTicket(path: $path) {\n    ticket\n  }\n}\n"
  }
};
})();

(node as any).hash = "a13dff12acf7875f2cd79ce6656a4365";

export default node;
